var isType = require('./is-type');

var isRegExp = function isRegExp(str) {
  return isType(str, 'RegExp');
};

module.exports = isRegExp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/type/is-reg-exp.js
// module id = 319
// module chunks = 0 1 2